module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/75/assets/images/91031f7380ec07010c8448056e942c07.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_present.svg
// module id = 0UoL
// module chunks = 0